module.exports = __webpack_public_path__ + "assets/img/dvipuse-apskaita.f720f00b.webp";